module.exports = __webpack_public_path__ + "img/stora_enso_logo.609dd1f2.png";